import React from "react";

const Clients = React.memo(() => <div>Clients Page</div>);

export default Clients;
